<template>
  <div v-if="enabled" class="container">
    <slot />
  </div>
  <slot v-else />
</template>

<script setup lang="ts">
/**
 * 支給デザインの `.container`（中央寄せ・最大幅・左右padding）。
 * 支給32本すべてに現れる最外殻。スタイルは renewal/style.css が持つのでここでは持たない。
 *
 * **`enabled` を `false` にすると器を描かずスロットだけを出す。**
 * 同じ中身を「`container` に入れる／入れない」で出し分けるページがあり
 * （`/cart` のアップセル有無。支給 `shopping-cart.html` と `shopping-cart_upsell-*.html` で
 * `container` の位置が違う）、`v-if` / `v-else` で書くと中身が二重管理になるため
 * （決定#5）。既定は `true` なので、既存の呼び出し55箇所の描画は変わらない。
 */
type Props = {
  /** `container` を描くか。`false` ならスロットだけを出す */
  enabled?: boolean;
};

withDefaults(defineProps<Props>(), {
  enabled: true,
});
</script>
